var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProducts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6992 8.79998H19.7992V20.9H2.19922V8.79998H3.29922V6.59998C3.29922 3.56398 5.76322 1.09998 8.79922 1.09998C9.58022 1.09998 10.3282 1.26498 10.9992 1.56198C11.6923 1.25632 12.4417 1.09895 13.1992 1.09998C16.2352 1.09998 18.6992 3.56398 18.6992 6.59998V8.79998ZM5.49922 6.59998V8.79998H7.69922V6.59998C7.69922 5.35698 8.12822 4.22398 8.82122 3.29998H8.79922C6.98422 3.29998 5.49922 4.78498 5.49922 6.59998ZM16.4992 8.79998V6.59998C16.4992 4.78498 15.0142 3.29998 13.1992 3.29998H13.1772C13.9005 4.24849 14.2945 5.40716 14.2992 6.59998V8.79998H16.4992ZM10.9992 4.15798C10.3282 4.76298 9.89922 5.63198 9.89922 6.59998V8.79998H12.0992V6.59998C12.0992 5.63198 11.6702 4.76298 10.9992 4.15798Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.88534ff08726b263fd03b60e22541097.svg";
export { ForwardRef as ReactComponent };